import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { format } from 'date-fns';
import { Button, Typography } from 'seagull';
import { Info } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import styles from './ChangesApprovalInfoBox.module.scss';
const InfoWrapper = (param)=>{
    let { displayDisableButton, children } = param;
    return displayDisableButton ? /*#__PURE__*/ _jsx("div", {
        className: styles.info,
        children: children
    }) : children;
};
export default function ChangesApprovalInfoBox(props) {
    const { testId, autoApprovalDate, className, showDisableButton } = props;
    const { t: approvalTexts } = useLocaleKeys('components.changesApprovalInfoBox');
    return /*#__PURE__*/ _jsxs(Typography, {
        className: cn(styles.infoBox, showDisableButton && styles.spaceWithDisable, className),
        skin: "primary",
        children: [
            /*#__PURE__*/ _jsxs(InfoWrapper, {
                displayDisableButton: showDisableButton,
                children: [
                    /*#__PURE__*/ _jsx(Info, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: testId,
                        children: autoApprovalDate ? "Will be automatically approved on ".concat(format(autoApprovalDate, 'MMMM d, yyyy'), " ", 'unless approved earlier or if auto-approval is disabled.') : approvalTexts.changesAwaitingApproval()
                    })
                ]
            }),
            showDisableButton && /*#__PURE__*/ _jsx(Button, {
                bi: {
                    name: 'disable_auto_approval'
                },
                onClick: props.onDisable,
                skin: "primaryOutline",
                testId: "disable-auto-approval-button",
                intent: Intent.DeclineAutoApproval,
                loading: props.disabling,
                className: styles.disableButton,
                children: approvalTexts.disableAutoApproval()
            })
        ]
    });
}
